import { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class ModalPortal extends PureComponent {
  el = document.getElementById('modal-root');

  componentDidMount() {
    this.hidePageOverflow();
  }

  componentWillUnmount() {
    this.resetPageOverflow();
  }

  hidePageOverflow = () => {
    document.body.style.overflow = 'hidden';
  };

  resetPageOverflow = () => {
    document.body.style.overflow = 'auto';
  };

  render() {
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

ModalPortal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModalPortal;
